import { type AuthInfo } from './auth-info';

export class AuthSession {
  private static instance: AuthSession | null = null;
  private readonly storageKey = import.meta.env.VITE_AUTH_SESSION_KEY as string;

  private constructor() {
    void 0;
  }

  public static getInstance(): AuthSession {
    if (!AuthSession.instance) {
      AuthSession.instance = new AuthSession();
    }
    return AuthSession.instance;
  }

  private readAuthInfo(): AuthInfo | null {
    try {
      const raw = sessionStorage.getItem(this.storageKey);
      if (!raw) return null;
      return JSON.parse(raw) as AuthInfo;
    } catch {
      return null;
    }
  }

  public getIdToken(): string | undefined {
    return this.readAuthInfo()?.idToken;
  }

  public getIdTokenClaims(): AuthInfo['idTokenClaims'] | undefined {
    return this.readAuthInfo()?.idTokenClaims;
  }

  public getPreferredUsername(): string | undefined {
    return this.readAuthInfo()?.idTokenClaims?.preferred_username;
  }

  public saveAuthInfo(info: AuthInfo): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(info));
  }

  public clear(): void {
    sessionStorage.removeItem(this.storageKey);
  }
}
